module.exports = __webpack_public_path__ + "static/media/skill4_pos_es.29e35b99.txt";